import { ReactNode } from 'react'
import styled from 'styled-components'

export const Button: React.FC<{
  colorMode?: 'light' | 'dark'
  children: ReactNode
  disabled?: boolean
  onClick?: () => void
  [key: string]: any
}> = ({
  colorMode = 'light',
  children,
  onClick,
  disabled = false,
  ...props
}) => {
  return (
    <ButtonRoot
      colorMode={colorMode}
      onClick={onClick}
      disabled={!disabled}
      {...props}
    >
      {children && children}
    </ButtonRoot>
  )
}

const ButtonRoot = styled.button<{
  colorMode: 'light' | 'dark'
  disabled: boolean
}>`
  padding: 15px 30px;
  letter-spacing: 0.6px;
  font-size: 18px;
  border: 0;
  color: ${({ colorMode, disabled }) =>
    disabled
      ? colorMode === 'dark'
        ? 'var(--gray-2)'
        : 'var(--brandblue-bright-2)'
      : colorMode === 'dark'
      ? 'var(--site-background)'
      : 'var(--text-color)'};

  background-color: ${({ colorMode, disabled }) =>
    disabled
      ? colorMode === 'dark'
        ? 'var(--gray-3)'
        : 'var(--gray-4)'
      : colorMode === 'dark'
      ? 'var(--yellow-main)'
      : 'var(--yellow-main)'};

  &:hover {
    cursor: pointer;
    opacity: ${({ disabled }) => (disabled ? '1' : '0.7')};
    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  }
`
